let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("dt38J")).then(() => parcelRequire('55RJF'));